/**
 * Client-side format validation for AWS IAM Role ARNs (ACME-1884).
 * Format only — does not call AWS. Templates keep variable-only rules; do not
 * run this regex on placeholders such as {RoleARN}.
 */

export const AWS_IAM_ROLE_ARN_REQUIRED_WARNING = 'Role ARN is required';

export const AWS_IAM_ROLE_ARN_FORMAT_WARNING =
    'Role ARN must match arn:aws:iam::<12-digit-account>:role/<role-name> (example: arn:aws:iam::160870909366:role/ExternalS3AccessRole)';

const MAX_LENGTH = 256;
const ROLE_NAME_MAX = 64;
const ROLE_ARN_RE = /^arn:aws:iam::[0-9]{12}:role(\/[A-Za-z0-9+=,.@_-]+)+$/;

export function isMaskedAwsIamRoleArn(value: string | undefined | null): boolean {
    const v = String(value ?? '');
    return v === '*****' || /^\*+$/.test(v);
}

/** Format-only. Empty is invalid here; callers decide required vs optional. */
export function isValidAwsIamRoleArn(value: string | undefined | null): boolean {
    const trimmed = String(value ?? '').trim();
    if (!trimmed || trimmed.length > MAX_LENGTH) return false;
    if (/\s/.test(trimmed)) return false;
    if (!ROLE_ARN_RE.test(trimmed)) return false;
    const lastSlash = trimmed.lastIndexOf('/');
    const roleName = lastSlash >= 0 ? trimmed.slice(lastSlash + 1) : '';
    return roleName.length >= 1 && roleName.length <= ROLE_NAME_MAX;
}

export function awsIamRoleArnWarning(
    value: string | undefined | null,
    options?: { required?: boolean }
): string | null {
    const trimmed = String(value ?? '').trim();
    const required = options?.required !== false;
    if (!trimmed) {
        return required ? AWS_IAM_ROLE_ARN_REQUIRED_WARNING : null;
    }
    if (isMaskedAwsIamRoleArn(trimmed)) return null;
    if (isValidAwsIamRoleArn(trimmed)) return null;
    return AWS_IAM_ROLE_ARN_FORMAT_WARNING;
}
